import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  GetServiceCaller,
  PostFormServiceCaller,
} from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import FileUploader from "../../../components/FileUploader";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const KnowledgeBase = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(updateNavbarHeading("Knowledge Base"));
  }, []);
  const initialFormData = {
    Name: "",
    Description: "",
    Domain_150: null,
    DocumentCategory_151: null,
    FileName: null,
    FileType_154: null,
    ApplicationStatus_123: 0,
  };

  const [formData, setFormData] = useState(initialFormData);
  const [filterData, setFilterData] = useState({
    search: "",
    DomainID: null,
    CategoryID: null,
  });
  const [domainOptions, setDomainOptions] = useState([]);
  const [documentCategoryOptions, setDocumentCategoryOptions] = useState([]);
  const [fileTypeOptions, setFileTypeOptions] = useState([]);
  const [documentListData, setDocumentListData] = useState([]);
  const [selectedPdf, setSelectedPdf] = useState(null); // Store selected PDF
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchIndexApi();
    handleGetData();
  }, []);

  const fetchIndexApi = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}nest/dashboard/knowledge-base`
      );

      if (response?.status === 200) {
        const cleanedData = response?.data?.data;
        const domOpt = cleanedData?.domain?.map((o) => ({
          value: o.value,
          label: o.text,
        }));
        setDomainOptions(domOpt);
        const documnetCatOpt = cleanedData?.documentcategory?.map((o) => ({
          value: o.value,
          label: o.text,
        }));
        setDocumentCategoryOptions(documnetCatOpt);
        const fileTYpeOpt = cleanedData?.filetype?.map((o) => ({
          value: o.value,
          label: o.text,
        }));
        setFileTypeOptions(fileTYpeOpt);
      }
    } catch (error) {
      console.error("Fetching Error ", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSelectChange = (selectedOption, { name }) => {
    setFilterData((prevData) => ({
      ...prevData,
      [name]: selectedOption?.value || null,
    }));
  };

  useEffect(() => {
    if (filterData?.DomainID) {
      handleGetData();
    }
  }, [filterData?.DomainID]);
  useEffect(() => {
    if (filterData?.CategoryID) {
      handleGetData();
    }
  }, [filterData?.CategoryID]);

  const [apiStatus, setApiStatus] = useState("");

  const handleGetData = async () => {
    setApiStatus(undefined);
    try {
      const response = await GetServiceCaller(
        `${API_URL}nest/dashboard/knowledge-base/search-document?contactid=&searchString=${
          filterData.search || ""
        }&domain_150=${filterData.DomainID || ""}&documentCategory_151=${
          filterData.CategoryID || ""
        }&p_Offset=`
      );

      if (response?.status === 200) {
        setApiStatus(response?.status);
        const cleanedData = response?.data?.docs;
        setDocumentListData(cleanedData || null);
      }
    } catch (error) {
      console.error("Fetching Error ", error);
    }
  };

  const handlePdfRender = (pdfData) => {
    setSelectedPdf(pdfData?.FilePath || "");
  };
  const [fileName, setFileName] = useState("");

  const [resumeFile, setResumeFile] = useState("");
  const handleFile = (file) => {
    if (file) {
      // Clear any previous error messages
      setErrors((prevErrors) => ({
        ...prevErrors,
        FileName: "",
      }));
      // Update form data and resume file state
      setFileName(file.name);
      setFormData((prevState) => ({
        ...prevState,
        FileName: file,
      }));
      validateField("FileName", file);
      setResumeFile(file);
    } else {
      // Set an error message if file is invalid
      setErrors((prevErrors) => ({
        ...prevErrors,
        FileName:
          "File size should not exceed 1MB and must be a PDF or Word document.",
      }));
    }
  };
  const [loading, setLoading] = useState(false);
  const schema = Yup.object().shape({
    Name: Yup.string().required("Title is required"),
    DocumentCategory_151: Yup.number()
      .typeError("Category is required")
      .required("Category is required"),
    Domain_150: Yup.number()
      .typeError("Domain is required")
      .required("Domain is required"),
    FileName: formData?.FileType_154
      ? Yup.string().required("File  is required")
      : Yup.string().nullable(),

    FileType_154: Yup.number()
      .typeError("File Type is required")
      .required("File Type is required"),
    Description: Yup.string(),
    ApplicationStatus_123: Yup.number(),
  });

  // Validate individual field
  const validateField = async (fieldName, updatedValue) => {
    try {
      await schema.validateAt(fieldName, { [fieldName]: updatedValue });
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    } catch (err) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: err.message,
      }));
    }
  };

  // Handle input change
  const handleUploadChange = (e) => {
    const { name, type, value, checked } = e.target;

    if (schema.fields[name]) {
      setFormData((prevData) => {
        // Use `checked` for checkboxes, `value` for other inputs
        const newValue = type === "checkbox" ? (checked ? 1 : 0) : value;
        const updatedData = { ...prevData, [name]: newValue };

        validateField(name, newValue); // Validate the field
        return updatedData;
      });
    }
  };

  // Handle select input change
  const handleSelect = (selectedOption, name) => {
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: selectedOption.value };
      validateField(name, selectedOption.value);
      return updatedData;
    });
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log("Submitting Form Data:", formData);

    try {
      await schema.validate(formData, { abortEarly: false });
      setErrors({});

      const response = await PostFormServiceCaller(
        `${API_URL}nest/dashboard/knowledge-base`,
        formData,
        "post"
      );

      if (response.status === 200) {
        toast.success("Knowledge Base added successfully");
        setTimeout(() => {
          navigate("/");
          setFormData(initialFormData);
          setFileName("");
          setResumeFile("");
        }, 2000);
      } else {
        console.error("Failed to submit data. Status:", response.status);
      }
    } catch (error) {
      if (error.inner) {
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        setErrors(validationErrors);
      } else {
        console.error("Data Posting Error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid" id="skill_section">
      <div className="container-fluid" id="skill-table-area">
        <form>
          {/* Tab Code Start */}
          <ul className="nav nav-tabs overflow" id="myTab" role="tablist">
            <li className="nav-item knowledge-tab" role="presentation">
              <button
                className="nav-link active"
                style={{ color: "#2F2E4B" }}
                id="search-tab"
                data-bs-toggle="tab"
                data-bs-target="#search"
                type="button"
                role="tab"
                aria-controls="search"
                aria-selected="true"
              >
                Search Knowledge Base
              </button>
            </li>
            <li className="nav-item knowledge-tab" role="presentation">
              <button
                className="nav-link"
                style={{ color: "#2F2E4B" }}
                id="upload-tab"
                data-bs-toggle="tab"
                data-bs-target="#upload"
                type="button"
                role="tab"
                aria-controls="upload"
                aria-selected="false"
              >
                Upload To Knowledge Base
              </button>
            </li>
          </ul>
          {/* Tab Code End */}

          <div className="tab-content" id="myTabContent">
            {/* Search Tab */}
            <div
              className="tab-pane fade show active p-2"
              id="search"
              role="tabpanel"
              aria-labelledby="search-tab"
            >
              <div className="row">
                <div className="col-md-3">
                  <label className="form-label">Global Search</label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search documents..."
                      aria-label="Search documents"
                      name="search"
                      onChange={handleChange}
                      onKeyPress={(e) => e.key === "Enter" && handleGetData()}
                      style={{
                        height: "38px", // Fixed height instead of calc
                        borderRight: "none",
                        borderTopRightRadius: "0",
                        borderBottomRightRadius: "0",
                      }}
                    />
                    <button
                      className="custom-btn"
                      type="button"
                      onClick={handleGetData}
                      style={{
                        height: "38px", // Same height as input
                        borderLeft: "none",
                        borderTopLeftRadius: "0",
                        borderBottomLeftRadius: "0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                  </div>
                </div>
                <div className="col-md-3">
                  <label className="form-label">By Domain</label>
                  <Select
                    options={domainOptions}
                    placeholder="Domain"
                    name="DomainID"
                    onChange={handleSelectChange}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">By Document Category</label>
                  <Select
                    options={documentCategoryOptions} // You can fill this with real data
                    placeholder="Category"
                    name="CategoryID"
                    onChange={handleSelectChange}
                  />
                </div>
                {/* <div className="col-md-3 mt-4 text-end">
                <button
                  type="button"
                  className="custom-btn"
                  onClick={handleGetData}
                >
                  Get Data
                </button>
              </div> */}
              </div>

              <div className="row">
                <p
                  className="fw-bold"
                  style={{ fontSize: "20px", marginBottom: "10px" }}
                >
                  <i className="bi bi-search"></i> My Documents: Search Result
                </p>

                <div className="row">
                  <div className="col-md-12">
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "16px",
                        width: "100%",
                      }}
                    >
                      {apiStatus === undefined ? (
                        // Loading state - centered
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "40px",
                          }}
                        >
                          <div style={{ textAlign: "center" }}>
                            <FaSpinner className="spinner" />
                            <p style={{ marginTop: "10px" }}>Loading</p>
                          </div>
                        </div>
                      ) : apiStatus === 200 && documentListData?.length > 0 ? (
                        // Data exists - render documents
                        documentListData.map((ele, index) => (
                          <div
                            key={index}
                            style={{
                              width: "calc(25% - 12px)",
                              minWidth: "250px",
                              backgroundColor: "#ffffff",
                              padding: "16px",
                              borderRadius: "8px",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              boxSizing: "border-box",
                              overflow: "hidden",
                              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                              transition: "all 0.3s ease",
                              border: "1px solid #e0e0e0",
                              marginBottom: "5px",
                              ":hover": {
                                transform: "translateY(-5px)",
                                boxShadow: "0 6px 12px rgba(0,0,0,0.15)",
                              },
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "12px",
                              }}
                            >
                              <span
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  minWidth: "40px",
                                }}
                                onClick={() => {
                                  // Open file when icon is clicked
                                  if (ele?.FilePath) {
                                    window.open(
                                      ele.FilePath,
                                      "_blank",
                                      "noopener,noreferrer"
                                    );
                                  }
                                }}
                              >
                                {ele?.FileType === "Excel" ? (
                                  <i
                                    className="pad-t-5 bi bi-file-earmark-excel-fill"
                                    style={{
                                      fontSize: "32px",
                                      color: "#21a366",
                                      marginBottom: "4px",
                                    }}
                                  ></i>
                                ) : ele?.FileType === "PPT" ? (
                                  <i
                                    className="pad-t-5 bi bi-file-earmark-ppt-fill"
                                    style={{
                                      fontSize: "32px",
                                      color: "#d24726",
                                      marginBottom: "4px",
                                    }}
                                  ></i>
                                ) : ele?.FileType === "PDF" ? (
                                  <i
                                    className="pad-t-5 fa fa-file-pdf-o"
                                    style={{
                                      fontSize: "32px",
                                      color: "#e74c3c",
                                      marginBottom: "4px",
                                    }}
                                  ></i>
                                ) : ele?.FileType === "Word" ? (
                                  <i
                                    className="pad-t-5 bi bi-file-earmark-word-fill"
                                    style={{
                                      fontSize: "32px",
                                      color: "#2b579a",
                                      marginBottom: "4px",
                                    }}
                                  ></i>
                                ) : ele?.FileType === "Text" ? (
                                  <i
                                    className="pad-t-5 bi bi-file-earmark-text-fill"
                                    style={{
                                      fontSize: "32px",
                                      color: "#555555",
                                      marginBottom: "4px",
                                    }}
                                  ></i>
                                ) : ele?.FileType === "Pitcure" ? (
                                  <i
                                    className="pad-t-5 bi bi-file-earmark-image-fill"
                                    style={{
                                      fontSize: "32px",
                                      color: "#e67e22",
                                      marginBottom: "4px",
                                    }}
                                  ></i>
                                ) : null}
                                <span
                                  style={{
                                    display: "block",
                                    fontSize: "11px",
                                    color: "#666",
                                    fontWeight: "500",
                                    backgroundColor: "#f5f5f5",
                                    padding: "2px 6px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  {(ele?.FileSize / 1024).toFixed(2) + "Kb" ||
                                    "50 kb"}
                                </span>
                              </span>

                              <div
                                style={{
                                  flex: 1,
                                  overflow: "hidden",
                                  minHeight: "80px",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div>
                                  <a
                                    href={ele?.FilePath}
                                    className="fancybox"
                                    data-type="iframe"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      fontWeight: "600",
                                      fontSize: "14px",
                                      color: "#2c3e50",
                                      textDecoration: "none",
                                      display: "-webkit-box",
                                      WebkitLineClamp: "2",
                                      WebkitBoxOrient: "vertical",
                                      overflow: "hidden",
                                      lineHeight: "1.4",
                                      marginBottom: "8px",
                                      ":hover": {
                                        color: "#3498db",
                                        textDecoration: "underline",
                                      },
                                    }}
                                  >
                                    {ele?.Name || "Document"}
                                  </a>

                                  <p
                                    style={{
                                      margin: "0",
                                      fontSize: "12px",
                                      color: "#7f8c8d",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "4px",
                                    }}
                                  >
                                    <i
                                      className="bi bi-person"
                                      style={{ fontSize: "12px" }}
                                    ></i>
                                    {ele?.UploadedByName || "Unknown"}
                                  </p>
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginTop: "8px",
                                    paddingTop: "8px",
                                    borderTop: "1px dashed #e0e0e0",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: "11px",
                                      color: "#95a5a6",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "4px",
                                    }}
                                  >
                                    <i
                                      className="bi bi-calendar3"
                                      style={{ fontSize: "11px" }}
                                    ></i>
                                    {moment(ele?.UploadedDate).format(
                                      "DD-MMM-YYYY"
                                    ) || "N/A"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : apiStatus === 200 &&
                        documentListData?.length === 0 ? (
                        // No data found - centered
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "40px",
                          }}
                        >
                          <div style={{ textAlign: "center" }}>
                            <i
                              className="bi bi-file-earmark-excel"
                              style={{ fontSize: "32px", color: "#ccc" }}
                            ></i>
                            <p
                              style={{
                                marginTop: "10px",
                                color: "#666",
                                fontSize: "16px",
                              }}
                            >
                              No documents found
                            </p>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Upload Tab */}
            <div
              className="tab-pane fade show p-2"
              id="upload"
              role="tabpanel"
              aria-labelledby="upload-tab"
            >
              <div className="mx-3">
                <div className="row row-flex">
                  <div className="col-md-12 flex-col">
                    <div className="card-body p-0">
                      <div className="row mt-2">
                        <div className="col-md-4">
                          <label className="form-label">
                            Title<span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="Name"
                            className={`form-control mb-1 ${
                              errors.Name ? "is-invalid" : ""
                            }`}
                            value={formData?.Name}
                            onChange={handleUploadChange}
                          />
                          {errors.Name && (
                            <div className="text-danger">
                              {errors.Name}
                            </div>
                          )}
                        </div>
                        <div className="col-md-4">
                          <label className="form-label">
                            Domain<span className="text-danger">*</span>
                          </label>

                          <Select
                            name="Domain_150"
                            options={domainOptions}
                            // className={`${
                            //   errors.Domain_150 ? "is-invalid" : ""
                            // }`}
                            value={domainOptions?.find(
                              (o) => o.value === formData?.Domain_150
                            )}
                            onChange={(selectedOption, action) =>
                              handleSelect(selectedOption, action.name)
                            }
                              styles={{
                      margin:"0px",
                      control: (base) => ({
                        ...base,
                        borderColor: errors.Domain_150
                          ? "#dc3545"
                          : base.borderColor,
                      }),
                    }}
                          />
                          {errors.Domain_150 && (
                            <div className="text-danger">
                              {errors.Domain_150}
                            </div>
                          )}
                        </div>
                        <div className="col-md-4">
                          <label className="form-label">
                            Category<span className="text-danger">*</span>
                          </label>
                          <Select
                            name="DocumentCategory_151"
                            // className={`${
                            //   errors.DocumentCategory_151 ? "is-invalid" : ""
                            // }`}
                            value={documentCategoryOptions?.find(
                              (o) => o.value === formData?.DocumentCategory_151
                            )}
                            options={documentCategoryOptions}
                            onChange={(selectedOption, action) =>
                              handleSelect(selectedOption, action.name)
                            }
                              styles={{
                      margin:"0px",
                      control: (base) => ({
                        ...base,
                        borderColor: errors.DocumentCategory_151
                          ? "#dc3545"
                          : base.borderColor,
                      }),
                    }}
                          />{" "}
                          {errors.DocumentCategory_151 && (
                            <div className="text-danger">
                              {errors.DocumentCategory_151}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="row mt-2 p-0">
                        <div className="col-md-4">
                          <label className="form-label">Document Details</label>
                          <textarea
                            name="Description"
                            className={`form-control ${
                              errors.Description ? "is-invalid" : ""
                            }`}
                            onChange={handleUploadChange}
                            value={formData?.Description}
                          ></textarea>
                        </div>

                        <div className="col-md-4">
                          <label className="form-label">
                            File Type<span className="text-danger">*</span>
                          </label>
                          <Select
                            options={fileTypeOptions}
                            // className={`${
                            //   errors.FileType_154 ? "is-invalid" : ""
                            // }`}
                            name="FileType_154"
                            value={fileTypeOptions?.find(
                              (o) => o.value === formData?.FileType_154
                            )}
                            onChange={(selectedOption, action) =>
                              handleSelect(selectedOption, action.name)
                            }
                              styles={{
                      margin:"0px",
                      control: (base) => ({
                        ...base,
                        borderColor: errors.FileType_154
                          ? "#dc3545"
                          : base.borderColor,
                      }),
                    }}
                          />
                          {errors.FileType_154 && (
                            <div className="text-danger">
                              {errors.FileType_154}
                            </div>
                          )}
                        </div>
                        <div className="col-md-2">
                          <div className="d-flex mt-4">
                            <div>
                              <div>
                                <FileUploader
                                  buttonLabel={"Upload"}
                                  handleFile={handleFile}
                                  isDisabled={
                                    formData.FileType_154 === null
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                              <span>
                                {resumeFile && (
                                  <p className="m-2">
                                    File:{" "}
                                    <a
                                      href={URL.createObjectURL(resumeFile)}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {fileName}
                                    </a>
                                  </p>
                                )}
                              </span>
                              {errors.FileName && (
                                <div className="error">{errors.FileName}</div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-2 text-center">
                          <div className="d-inline-flex align-items-center gap-2 mt-4 pt-1">
                            <input
                              type="checkbox"
                              className="form-check-input m-0"
                              name="ApplicationStatus_123"
                              value={formData?.ApplicationStatus_123}
                              onChange={handleUploadChange}
                            />
                            <label className="form-check-label m-0">
                              Need Approval
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="d-flex justify-content-end">
                    <div className="d-flex me-2">
                      <div>
                        <button
                          type="button"
                          className="cancel-btn me-2"
                          onClick={() => navigate(`/`)}
                        >
                          Cancel
                        </button>
                      </div>
                      <div>
                        <button
                          disabled={loading ? true : false}
                          type="button"
                          onClick={handleSubmit}
                          className="custom-btn"
                        >
                          {loading ? (
                            <FaSpinner class="sm-spinner" />
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default KnowledgeBase;
